__turbopack_context__.v({
  "button": "FloatingButton-module-scss-module__PYri2a__button",
});
